import React, { useCallback } from 'react';
import HorizontalProductList from 'features/products/components/HorizontalProductList';
import { useTranslation } from 'context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const CategorySection = ({ categoryData }) => {
  const navigate = useNavigate();
  const { t, language } = useTranslation();
  
  // Extract data before early returns
  const id = categoryData?.id;
  const name = categoryData?.name;
  const products = categoryData?.products || [];
  const isRTL = language === 'ar';
  
  // Memoized navigation handler for better performance
  const handleShowAll = useCallback(() => {
    navigate(`/category/${id}/products`, { 
      state: { categoryName: name, categoryId: id } 
    });
  }, [id, name, navigate]);

  // Early returns after all hooks
  if (!categoryData) return null;
  if (products.length === 0) return null;

  return (
    <section className="mb-6" aria-labelledby={`category-${id}-title`}>
      {/* Header Row: Category Name and Show All Button */}
      <div className="flex items-center justify-between mb-4 px-4">
        {/* Category Name */}
        <h2 
          id={`category-${id}-title`}
          className="text-xl md:text-2xl font-bold text-gray-900"
        >
          {name}
        </h2>
        
        {/* Show All Button */}
        <button 
          className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          onClick={handleShowAll}
          aria-label={`${t('showAll')} ${name} products`}
        >
          <span className="font-medium text-sm md:text-base">{t('showAll')}</span>
          <ChevronRight 
            className={`w-4 h-4 transition-transform group-hover:translate-x-1 ${isRTL ? 'rotate-180' : ''}`}
            aria-hidden="true"
          />
        </button>
      </div>

      {/* Products Horizontal List */}
      <div className="px-4">
        <HorizontalProductList products={products} />
      </div>

    </section>
  );
};

export default CategorySection;
